<template>
  <div>
    <transition name="scroll-dialog">
      <div v-if="openDialog" class="text-white account-dialog">
        <b-navbar class="account-nav" toggleable="lg">
          <b-navbar-nav>
            <div class="account-nav-title text-white">
              <b-icon-gear></b-icon-gear>
              <span class="pl-1">アカウント管理</span>
            </div>
          </b-navbar-nav>

          <b-navbar-nav class="account-nav-right ml-auto">
            <b-button size="lg" class="account-button-close" @click="onClose"
              ><b-icon-x></b-icon-x
            ></b-button>
          </b-navbar-nav>
        </b-navbar>

        <section class="section-regist-info">
          <h3 class="title">登録情報</h3>
          <p
            class="ml-auto edit-button"
            v-bind:class="{ edited: !edited }"
            @click="onEdit"
          >
            <b-icon-pencil></b-icon-pencil> 登録内容を編集
          </p>
          <div class="content">
            <b-row>
              <b-col cols="8">
                <b-form-group
                  id="username"
                  label="ユーザー名"
                  label-for="username"
                  description=""
                >
                  <b-form-input
                    id="username"
                    v-model="form.username"
                    type="text"
                    placeholder="xxxx@xxxx.com"
                    :disabled="edited"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="4"> </b-col>
            </b-row>
            <b-row>
              <b-col cols="5">
                <b-form-group
                  id="password"
                  label="前のパスワード"
                  label-for="password"
                  description=""
                >
                  <b-form-input
                    id="password"
                    v-model="form.password"
                    type="password"
                    placeholder="前のパスワード"
                    :disabled="edited"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="5">
                <b-form-group
                  id="password_retype"
                  label="半角英数字6文字以上"
                  label-for="password_retype"
                  label-class="text-secondary text-right"
                  description=""
                >
                  <b-form-input
                    id="password_retype"
                    v-model="form.password_retype"
                    type="password"
                    placeholder="パスワード"
                    :disabled="edited"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="2"> </b-col>
            </b-row>
            <b-row>
              <b-col cols="8">
                <b-form-group
                  id="email"
                  label="メールアドレス"
                  label-for="email"
                  description=""
                >
                  <b-form-input
                    id="email"
                    v-model="form.email"
                    type="email"
                    placeholder="xxxx@xxxx.com"
                    :disabled="edited"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="4"> </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <b-form-group
                  id="first-name"
                  label="お名前"
                  label-for="first-name"
                  description=""
                >
                  <b-form-input
                    id="first-name"
                    v-model="form.first_name"
                    type="text"
                    placeholder="サンプル"
                    :disabled="edited"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group
                  id="last-name"
                  label=""
                  label-for="last-name"
                  description=""
                >
                  <b-form-input
                    id="last-name"
                    v-model="form.last_name"
                    type="text"
                    class="non-label-margin"
                    placeholder="ジロウ"
                    :disabled="edited"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="submit-button">
                <b-button
                  variant="primary"
                  :disabled="edited"
                  @click="updateUserinfo()"
                  >変更を保存</b-button
                >
              </b-col>
            </b-row>
            <b-row> </b-row>
          </div>
        </section>

        <section class="section-project">
          <h3 class="title">プロジェクト</h3>
          <div class="content text-white">
            <h4>
              <b-icon-folder-fill></b-icon-folder-fill>
              <span class="project-name">{{ project.name }}</span>
            </h4>

            <div class="project-content">
              <b-row
                ><span class="content-header"
                  >最終保存日：{{ project.updated_date }}</span
                ></b-row
              >
              <b-row
                ><span class="content-header"
                  >最新ダウンロード申請日：{{
                    project.latest_download_post_date
                  }}</span
                ></b-row
              >
              <b-row
                ><span class="content-header"
                  >最新ダウンロード申請内容：{{
                    project.latest_download_details
                  }}</span
                ></b-row
              >
              <b-row
                ><span class="content-header"
                  >最新入金ステータス：{{ project.payment_status }}</span
                ></b-row
              >
              <b-row
                ><span class="content-header"
                  >最新ダウンロード日：{{ project.latest_download_date }}</span
                ></b-row
              >
            </div>

            <div class="project-buttons">
              <b-button variant="primary"
                >申請したアートのダウンロード</b-button
              >
              <div class="help-icon" id="project-art-download-help">
                <b-icon-question-circle-fill
                  shift-v="8"
                ></b-icon-question-circle-fill>
              </div>

              <b-button variant="primary">プロジェクトの編集</b-button>
              <div class="help-icon" id="project-edit-help">
                <b-icon-question-circle-fill
                  shift-v="8"
                ></b-icon-question-circle-fill>
              </div>

              <b-popover target="project-art-download-help" triggers="hover">
                弊社にて入金の確認が出来次第、ダウンロードが可能になります。
                通常入金から2営業日以内にダウンロードできるようになります。
                入金後数日経ってもダウンロードができない場合は、お手数ですがこちらよりお問い合わせください。
              </b-popover>

              <b-popover target="project-edit-help" triggers="hover">
                ダウンロードの申請中はプロジェクトの編集はできません。
                入金してダウンロードを行った後、プロジェクトの編集と新たにダウンロードの申請などを行うことができます。
              </b-popover>
            </div>
          </div>
        </section>

        <div class="alert-area">
          <b-alert
            :show="successAlertCount"
            variant="success"
            @dismissed="successAlertCount = 0"
            @dismiss-count-down="countDownChanged"
            >更新が完了しました｡</b-alert
          >
          <b-alert
            :show="dangerAlertCount"
            variant="danger"
            @dismissed="dangerAlertCount = 0"
            @dismiss-count-down="countDownChanged"
            >更新に失敗しました</b-alert
          >
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Const from "../common/Const";
import axios from "axios";
export default {
  name: "Account",
  props: ["openDialog"],
  data() {
    return {
      edited: true,
      project: {
        name: "ねこのたまプロジェクト",
        updated_date: "",
        latest_download_post_date: "",
        latest_download_date: "",
        latest_download_details: "",
        payment_status: "",
      },
      form: {
        email: "",
        username: "",
        first_name: "",
        last_name: "",
        password: "",
        password_retype: "",
      },
      successAlertCount: 0,
      dangerAlertCount: 0,
    };
  },
  mounted() {
    axios
      .get(`${Const.API_URL_BASE}/user_info/${this.$cognito.getUserId()}`, {
        headers: { Authorization: this.$cognito.getToken() },
      })
      .then((res) => {
        console.log(res.data);
        this.form.email = res.data.email;
        this.form.username = res.data.user_name;

        const project = res.data.project[0];
        this.project.name = project.name;
        this.project.updated_date = project.updated_date;
      });
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    onClose() {
      this.$emit("closeDialog");
    },
    onEdit() {
      this.edited = !this.edited;
    },
    updateUserinfo() {
      const request = {
        user_name: this.form.username,
        email: this.form.email,
      };
      axios
        .put(
          `${Const.API_URL_BASE}/users/${this.$cognito.getUserId()}`,
          request,
          {
            headers: { Authorization: this.$cognito.getToken() },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            this.successAlertCount = 3;
          } else {
            this.dangerAlertCount = 3;
          }
        });
    },
    countDownChanged(dismissCountDown) {
      this.successAlertCount !== 0 ? dismissCountDown : 0;
      this.dangerAlertCount !== 0 ? dismissCountDown : 0;
    },
  },
};
</script>

<style scoped>
/* ダイアログ全体 */
.account-dialog {
  width: 100%;
  height: 100%;
  background-color: #1c1c1c;
  position: absolute;
  top: 0;
  z-index: 100;
  font-family: "Noto Sans JP", sans-serif;
  overflow: hidden;
}

/* ナビゲーション部分 */
.account-nav-title {
  font-size: 18px;
  margin-left: 68.8px;
  letter-spacing: 0px;
}

.account-nav {
  height: 70px;
  box-shadow: 0px 10px 10px #000;
  background-color: #1c1c1c;
}

.account-nav-right {
  margin-left: auto;
  margin-right: 60px;
}

.account-button-close {
  background-color: rgba(0, 0, 0, 0);
  border: none;
  font-size: 40px;
  line-height: 40px;
  font-weight: 0;
}

.scroll-dialog-enter-active,
.scroll-dialog-leave-active {
  transition: top 0.5s;
}
.scroll-dialog-enter,
.scroll-dialog-leave-to {
  top: 100%;
}

/* セクション共通 */
section {
  width: 675px;
  margin-left: 100px;
  margin-top: 100px;
  text-align: left;
}

section h3 {
  margin-left: -13px;
  text-align: left;
  font-size: 18px;
  font-family: "Noto Sans JP", sans-serif;
  font-weight: 300;
}

section h3:before {
  content: "|";
  position: relative;
  width: 4px;
  height: 26px;
  line-height: 26px;
  font-size: 28px;
  font-weight: bold;
  left: -10px;
  color: #fff;
}

/* Section 1 登録情報 */

.section-regist-info {
  text-align: left;
}

.section-regist-info p {
  margin-bottom: 5px;
  margin-right: 20px;
}

.section-regist-info .edit-button {
  font-size: 12px;
  color: #fff;
  text-decoration: underline #fff;
  cursor: pointer;
  text-align: right;
}

.section-regist-info .edited {
  color: #7a7a7a;
}

.section-regist-info .content {
  background-color: rgba(255, 255, 255, 0.05);
  padding: 0 20px;
  padding-top: 10px;
  padding-bottom: 5px;
}

.section-regist-info .content .row {
  margin-top: 20px;
}

.section-regist-info .text-weight-200 {
  font-weight: 200;
}

.section-regist-info input {
  margin-top: 5px;
}

.section-regist-info .non-label-margin {
  margin-top: 29px;
}

.section-regist-info .submit-button {
  text-align: right;
}
.section-regist-info .submit-button button {
  width: 120px;
  height: 40px;
  background-color: #168be2;
  margin-top: 28px;
  font-weight: 200;
  font-family: "Noto Sans JP", sans-serif;
}

/* Section 2 プロジェクト */
.section-project {
}

.section-project .content {
  margin-top: 32px;
  width: 600px;
}

.section-project .project-name {
  font-size: 16px;
  font-weight: 200;
}

.section-project .project-content {
  margin-top: 16px;
  color: #000;
}

.section-project .project-content > .row {
  background-color: #fff;
  height: 43px;
  line-height: 43px;
  font-size: 14px;
  margin-left: 0;
}

.section-project .project-content > .row:nth-child(even) {
  background-color: #ebebeb;
}

.section-project .content-header {
  padding-left: 10px;
  font-weight: bold;
}

.section-project .project-buttons {
  margin-top: 18px;
}

.section-project .project-buttons button {
  height: 40px;
  background-color: #168be2;
  font-weight: 300;
  font-size: 16px;
  padding: 0 28px;
  font-family: "Noto Sans JP", sans-serif;
}

.section-project .project-buttons .help-icon {
  margin-left: 4px;
  margin-right: 32px;
  display: inline-block;
}

.alert-area {
  position: absolute;
  width: 100%;
  height: 60px;
  bottom: 0;
  padding: 0 10%;
}
</style>


// WEBPACK FOOTER //
// src/components/Account.vue